(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6134,9495],{

/***/ 82934:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(58412);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlogCard_BlogCard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/BlogSection/BlogCard/BlogCard.module.scss
var BlogCard_module = __webpack_require__(53206);
var BlogCard_module_default = /*#__PURE__*/__webpack_require__.n(BlogCard_module);
// EXTERNAL MODULE: ./components/BlogSection/BlogImage/BlogImage.tsx
var BlogImage = __webpack_require__(64196);
;// CONCATENATED MODULE: ./components/BlogSection/BlogCard/BlogCard.tsx





var BlogCard = function(param) {
    var post = param.post, _noBorderRadius = param.noBorderRadius, noBorderRadius = _noBorderRadius === void 0 ? false : _noBorderRadius;
    // Function to check if body has actual content (not just empty HTML tags)
    var hasActualContent = function(htmlContent) {
        if (!htmlContent) return false;
        // Remove all HTML tags using regex (works in both client and server)
        var textContent = htmlContent.replace(/<[^>]*>/g, "");
        // Decode HTML entities
        var decodedContent = textContent.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        // Remove all whitespace and check if there's actual content
        var cleanedContent = decodedContent.trim().replace(/\s+/g, " ");
        return cleanedContent.length > 0;
    };
    var hasBody = hasActualContent(post.body);
    var isClickable = hasBody && post.slug;
    var handleClick = function() {
        if (isClickable) {
            window.location.href = "/news/".concat(post.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((BlogCard_module_default()).card, " ").concat(noBorderRadius ? (BlogCard_module_default()).noBorderRadius : "", " ").concat(isClickable ? (BlogCard_module_default()).clickable : (BlogCard_module_default()).notClickable),
        onClick: handleClick,
        role: isClickable ? "button" : undefined,
        tabIndex: isClickable ? 0 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((BlogCard_module_default()).cardImage, " ").concat(noBorderRadius ? (BlogCard_module_default()).noBorderRadius : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogImage/* default */.Z, {
                    src: post.image,
                    alt: post.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    isClickable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardTags,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (BlogCard_module_default()).tag,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.category
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (BlogCard_module_default()).readTime,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.readTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                as: "h3",
                                color: "grayDark-50",
                                className: (BlogCard_module_default()).cardTitle,
                                children: post.title
                            }),
                            isClickable && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                className: (BlogCard_module_default()).linkIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M4 12L12 4M4 4H12V12",
                                    stroke: "currentColor",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                        variant: "text-md",
                        as: "p",
                        color: "grayDark-400",
                        className: (BlogCard_module_default()).cardDescription,
                        children: post.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardAuthor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlogCard_module_default()).authorAvatar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: post.author.avatar,
                                    alt: post.author.name,
                                    width: 40,
                                    height: 40,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BlogCard_module_default()).authorInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "primary",
                                        weight: "medium",
                                        children: post.author.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "grayDark-400",
                                        children: post.author.date
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogCard_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/BlogSection/BlogCard/index.ts



/***/ }),

/***/ 64196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);




// The blog carousel renders several clones of each slide for its infinite-loop
// effect (react-slick), so the same image src mounts multiple times. Without
// this cache, each mounted instance below would independently fetch() and
// blob the same remote image, multiplying network requests by the clone count.
var blobUrlCache = new Map();
var getCachedObjectUrl = function(src) {
    var entry = blobUrlCache.get(src);
    if (!entry) {
        entry = fetch(src, {
            method: "GET",
            credentials: "omit"
        }).then(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(response) {
                var blob, finalBlob, urlLower, mimeType;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!response.ok) throw new Error("Failed to fetch image: ".concat(response.status));
                            return [
                                4,
                                response.blob()
                            ];
                        case 1:
                            blob = _state.sent();
                            finalBlob = blob;
                            if (!blob.type || blob.type === "application/octet-stream") {
                                urlLower = src.toLowerCase();
                                mimeType = "image/jpeg";
                                if (urlLower.includes(".png")) mimeType = "image/png";
                                else if (urlLower.includes(".gif")) mimeType = "image/gif";
                                else if (urlLower.includes(".webp")) mimeType = "image/webp";
                                finalBlob = new Blob([
                                    blob
                                ], {
                                    type: mimeType
                                });
                            }
                            return [
                                2,
                                URL.createObjectURL(finalBlob)
                            ];
                    }
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }());
        blobUrlCache.set(src, entry);
        entry.catch(function() {
            return blobUrlCache.delete(src);
        });
    }
    return entry;
};
var BlogImage = function(param) {
    var src = param.src, alt = param.alt, _className = param.className, className = _className === void 0 ? "" : _className, _fallbackSrc = param.fallbackSrc, fallbackSrc = _fallbackSrc === void 0 ? "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80" : _fallbackSrc;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src), imageSrc = ref[0], setImageSrc = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasError = ref1[0], setHasError = ref1[1];
    var triedOriginalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // Try to load image as blob if it's from media/view API. The blob/object URL
    // itself is cached by src in getCachedObjectUrl above, so carousel clones of
    // the same slide share one network fetch instead of issuing one each.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasError(false);
        triedOriginalRef.current = false;
        if (src && src.includes("/media/view?")) {
            var cancelled = false;
            getCachedObjectUrl(src).then(function(url) {
                if (!cancelled) setImageSrc(url);
            }).catch(function(error) {
                console.warn("Failed to load image as blob, using direct URL:", error);
                if (!cancelled) setImageSrc(src);
            });
            return function() {
                cancelled = true;
            };
        }
        setImageSrc(src);
    }, [
        src
    ]);
    var handleError = function() {
        if (hasError) return;
        // The shared object URL failed to render - try the original src once before
        // giving up on the remote image entirely.
        if (!triedOriginalRef.current && src && src !== imageSrc) {
            triedOriginalRef.current = true;
            setImageSrc(src);
            return;
        }
        console.warn("Image failed to load:", imageSrc);
        setHasError(true);
        setImageSrc(fallbackSrc);
    };
    var handleLoad = function() {
        setHasError(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: imageSrc,
        alt: alt,
        className: className,
        onError: handleError,
        onLoad: handleLoad,
        loading: "lazy"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogImage);


/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageWrapper_PageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(83767);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/PageWrapper/PageWrapper.module.scss
var PageWrapper_module = __webpack_require__(70930);
var PageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(PageWrapper_module);
;// CONCATENATED MODULE: ./components/PageWrapper/PageWrapper.tsx






var PageWrapper = function(param) {
    var dateText = param.dateText, titleText = param.titleText, introText = param.introText, _headerContainerClass = param.headerContainerClass, headerContainerClass = _headerContainerClass === void 0 ? "" : _headerContainerClass, _headerSectionClass = param.headerSectionClass, headerSectionClass = _headerSectionClass === void 0 ? "" : _headerSectionClass, _contentContainerClass = param.contentContainerClass, contentContainerClass = _contentContainerClass === void 0 ? "" : _contentContainerClass, children = param.children, aboutData = param.aboutData, additionalHeaderContent = param.additionalHeaderContent, additionalContent = param.additionalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PageWrapper_module_default()).pageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((PageWrapper_module_default()).headerContainer, " ").concat((PageWrapper_module_default()).pattern, " ").concat(headerContainerClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "".concat((PageWrapper_module_default()).headerSection, " ").concat(headerSectionClass),
                        children: [
                            !!dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).dateContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).dateText,
                                    children: dateText
                                })
                            }),
                            !!titleText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).titleContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "display-lg",
                                    as: "h1",
                                    color: "primary",
                                    weight: "bold",
                                    className: (PageWrapper_module_default()).mainTitle,
                                    children: titleText
                                })
                            }),
                            !!introText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).introContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).introText,
                                    children: introText
                                })
                            }),
                            additionalHeaderContent
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat((PageWrapper_module_default()).contentContainer, " ").concat(contentContainerClass),
                    children: children
                }),
                additionalContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                    aboutData: aboutData
                })
            ]
        })
    });
};
/* harmony default export */ var PageWrapper_PageWrapper = (PageWrapper);

;// CONCATENATED MODULE: ./components/PageWrapper/index.ts



/***/ }),

/***/ 58412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ news; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(38104);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/BlogList/BlogSidebar.module.scss
var BlogSidebar_module = __webpack_require__(1421);
var BlogSidebar_module_default = /*#__PURE__*/__webpack_require__.n(BlogSidebar_module);
;// CONCATENATED MODULE: ./components/BlogList/BlogSidebar.tsx





var BlogSidebar = function(param) {
    var categories = param.categories, selectedCategory = param.selectedCategory, onCategoryChange = param.onCategoryChange, searchQuery = param.searchQuery, onSearchChange = param.onSearchChange;
    var ref;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var handleToggle = function() {
        setIsOpen(!isOpen);
    };
    var handleCategoryClick = function(category) {
        onCategoryChange(category);
        setIsOpen(false); // Close dropdown after selection
    };
    // Get selected category name for display
    var selectedCategoryName = selectedCategory === "all" ? "View all" : ((ref = categories.find(function(cat) {
        return cat.slug === selectedCategory;
    })) === null || ref === void 0 ? void 0 : ref.name) || "Select category";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BlogSidebar_module_default()).sidebar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BlogSidebar_module_default()).dropdownWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (BlogSidebar_module_default()).dropdownButton,
                        onClick: handleToggle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: selectedCategoryName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineDown */.cuw, {
                                size: 16,
                                className: "".concat((BlogSidebar_module_default()).dropdownIcon, " ").concat(isOpen ? (BlogSidebar_module_default()).open : "")
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogSidebar_module_default()).dropdownContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat((BlogSidebar_module_default()).categoryItem, " ").concat(selectedCategory === "all" ? (BlogSidebar_module_default()).active : ""),
                                onClick: function() {
                                    return handleCategoryClick("all");
                                },
                                children: "View all"
                            }),
                            categories.map(function(category) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((BlogSidebar_module_default()).categoryItem, " ").concat(selectedCategory === category.slug ? (BlogSidebar_module_default()).active : ""),
                                    onClick: function() {
                                        return handleCategoryClick(category.slug);
                                    },
                                    children: category.name
                                }, category._id);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BlogSidebar_module_default()).desktopSidebar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BlogSidebar_module_default()).searchContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BlogSidebar_module_default()).searchInput,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    className: (BlogSidebar_module_default()).searchIcon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M7.33329 12.6667C10.2788 12.6667 12.6666 10.2789 12.6666 7.33333C12.6666 4.38781 10.2788 2 7.33329 2C4.38777 2 1.99996 4.38781 1.99996 7.33333C1.99996 10.2789 4.38777 12.6667 7.33329 12.6667Z",
                                            stroke: "currentColor",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M14 14L11.1 11.1",
                                            stroke: "currentColor",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search",
                                    value: searchQuery,
                                    onChange: function(e) {
                                        return onSearchChange(e.target.value);
                                    },
                                    className: (BlogSidebar_module_default()).input
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogSidebar_module_default()).categoriesSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-md",
                                as: "h3",
                                color: "primary",
                                weight: "bold",
                                className: (BlogSidebar_module_default()).sectionTitle,
                                children: "Blog categories"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BlogSidebar_module_default()).categoriesList,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat((BlogSidebar_module_default()).categoryItem, " ").concat(selectedCategory === "all" ? (BlogSidebar_module_default()).active : ""),
                                        onClick: function() {
                                            return onCategoryChange("all");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "primary",
                                            children: "View all"
                                        })
                                    }),
                                    categories.map(function(category) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "".concat((BlogSidebar_module_default()).categoryItem, " ").concat(selectedCategory === category.slug ? (BlogSidebar_module_default()).active : ""),
                                            onClick: function() {
                                                return onCategoryChange(category.slug);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                variant: "text-sm",
                                                color: "primary",
                                                children: category.name
                                            })
                                        }, category._id);
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogList_BlogSidebar = (BlogSidebar);

// EXTERNAL MODULE: ./components/BlogSection/BlogCard/index.ts + 1 modules
var BlogCard = __webpack_require__(21876);
// EXTERNAL MODULE: ./components/BlogList/FeaturedBlogCard.module.scss
var FeaturedBlogCard_module = __webpack_require__(65929);
var FeaturedBlogCard_module_default = /*#__PURE__*/__webpack_require__.n(FeaturedBlogCard_module);
// EXTERNAL MODULE: ./components/BlogSection/BlogImage/BlogImage.tsx
var BlogImage = __webpack_require__(64196);
;// CONCATENATED MODULE: ./components/BlogList/FeaturedBlogCard.tsx





var FeaturedBlogCard = function(param) {
    var post = param.post, _noBorderRadius = param.noBorderRadius, noBorderRadius = _noBorderRadius === void 0 ? false : _noBorderRadius;
    // Function to check if body has actual content (not just empty HTML tags)
    var hasActualContent = function(htmlContent) {
        if (!htmlContent) return false;
        // Remove all HTML tags using regex (works in both client and server)
        var textContent = htmlContent.replace(/<[^>]*>/g, "");
        // Decode HTML entities
        var decodedContent = textContent.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        // Remove all whitespace and check if there's actual content
        var cleanedContent = decodedContent.trim().replace(/\s+/g, " ");
        return cleanedContent.length > 0;
    };
    var hasBody = hasActualContent(post.body);
    var isClickable = hasBody && post.slug;
    var handleClick = function() {
        if (isClickable) {
            window.location.href = "/news/".concat(post.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((FeaturedBlogCard_module_default()).featuredCard, " ").concat(noBorderRadius ? (FeaturedBlogCard_module_default()).noBorderRadius : "", " ").concat(isClickable ? (FeaturedBlogCard_module_default()).clickable : (FeaturedBlogCard_module_default()).notClickable),
        onClick: handleClick,
        role: isClickable ? "button" : undefined,
        tabIndex: isClickable ? 0 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((FeaturedBlogCard_module_default()).imageSection, " ").concat(noBorderRadius ? (FeaturedBlogCard_module_default()).noBorderRadius : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogImage/* default */.Z, {
                    src: post.image,
                    alt: post.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FeaturedBlogCard_module_default()).contentSection,
                children: [
                    isClickable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FeaturedBlogCard_module_default()).cardTags,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (FeaturedBlogCard_module_default()).tag,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.category
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (FeaturedBlogCard_module_default()).readTime,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.readTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FeaturedBlogCard_module_default()).titleWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                            variant: "display-xs",
                            as: "h2",
                            color: "primary",
                            className: (FeaturedBlogCard_module_default()).title,
                            children: post.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FeaturedBlogCard_module_default()).descriptionWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                            variant: "text-md",
                            as: "p",
                            color: "grayDark-400",
                            className: (FeaturedBlogCard_module_default()).description,
                            children: post.description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FeaturedBlogCard_module_default()).cardAuthor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FeaturedBlogCard_module_default()).authorAvatar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: post.author.avatar,
                                    alt: post.author.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FeaturedBlogCard_module_default()).authorInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "primary",
                                        weight: "medium",
                                        children: post.author.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "grayDark-400",
                                        children: post.author.date
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogList_FeaturedBlogCard = (FeaturedBlogCard);

// EXTERNAL MODULE: ./components/BlogList/BlogPagination.module.scss
var BlogPagination_module = __webpack_require__(72238);
var BlogPagination_module_default = /*#__PURE__*/__webpack_require__.n(BlogPagination_module);
;// CONCATENATED MODULE: ./components/BlogList/BlogPagination.tsx



var BlogPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, onPageChange = param.onPageChange;
    var getPageNumbers = function() {
        var pages = [];
        var maxVisible = 6;
        if (totalPages <= maxVisible) {
            // Show all pages if total is less than maxVisible
            for(var i = 1; i <= totalPages; i++){
                pages.push(i);
            }
        } else {
            // Show first page
            if (currentPage <= 3) {
                for(var i1 = 1; i1 <= 6; i1++){
                    pages.push(i1);
                }
            } else if (currentPage >= totalPages - 2) {
                for(var i2 = totalPages - 5; i2 <= totalPages; i2++){
                    pages.push(i2);
                }
            } else {
                for(var i3 = currentPage - 2; i3 <= currentPage + 2; i3++){
                    pages.push(i3);
                }
            }
        }
        return pages;
    };
    var handlePrevious = function() {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };
    var handleNext = function() {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BlogPagination_module_default()).paginationContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BlogPagination_module_default()).desktopPagination,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (BlogPagination_module_default()).paginationButton,
                        onClick: handlePrevious,
                        disabled: currentPage === 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M10 12L6 8l4-4",
                                    stroke: "currentColor",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Previous"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BlogPagination_module_default()).paginationNumbers,
                        children: getPageNumbers().map(function(page, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat((BlogPagination_module_default()).paginationNumber, " ").concat(currentPage === page ? (BlogPagination_module_default()).active : ""),
                                onClick: function() {
                                    return onPageChange(page);
                                },
                                children: page
                            }, "page-".concat(index, "-").concat(page));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (BlogPagination_module_default()).paginationButton,
                        onClick: handleNext,
                        disabled: currentPage === totalPages,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Next"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M6 4l4 4-4 4",
                                    stroke: "currentColor",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BlogPagination_module_default()).mobilePagination,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (BlogPagination_module_default()).mobilePaginationButton,
                        onClick: handlePrevious,
                        disabled: currentPage === 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M10 12L6 8l4-4",
                                stroke: "currentColor",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogPagination_module_default()).pageInfo,
                        children: [
                            "Page ",
                            currentPage,
                            " of ",
                            totalPages
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (BlogPagination_module_default()).mobilePaginationButton,
                        onClick: handleNext,
                        disabled: currentPage === totalPages,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M6 4l4 4-4 4",
                                stroke: "currentColor",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogList_BlogPagination = (BlogPagination);

// EXTERNAL MODULE: ./pages/news/news.module.scss
var news_module = __webpack_require__(6250);
var news_module_default = /*#__PURE__*/__webpack_require__.n(news_module);
// EXTERNAL MODULE: ./components/PageWrapper/index.ts + 1 modules
var PageWrapper = __webpack_require__(96424);
// EXTERNAL MODULE: ./utils/index.ts
var utils = __webpack_require__(95656);
// EXTERNAL MODULE: ./components/SEO/index.ts + 1 modules
var SEO = __webpack_require__(38743);
;// CONCATENATED MODULE: ./pages/news/index.tsx











// Helper function to format date as "18 Jan 2025"
var formatDate = function(dateString) {
    var date = new Date(dateString);
    var day = date.getDate();
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec", 
    ];
    var month = monthNames[date.getMonth()];
    var year = date.getFullYear();
    return "".concat(day, " ").concat(month, " ").concat(year);
};
var BlogListPage = function(param) {
    var initialPosts = param.initialPosts, categories = param.categories, totalPosts = param.totalPosts, aboutData = param.aboutData;
    var ref = (0,react.useState)(initialPosts), posts = ref[0], setPosts = ref[1];
    var ref1 = (0,react.useState)(initialPosts), filteredPosts = ref1[0], setFilteredPosts = ref1[1];
    var ref2 = (0,react.useState)(1), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = (0,react.useState)(""), searchQuery = ref3[0], setSearchQuery = ref3[1];
    var ref4 = (0,react.useState)("all"), selectedCategory = ref4[0], setSelectedCategory = ref4[1];
    var ref5 = (0,react.useState)(false), isLoading = ref5[0], setIsLoading = ref5[1];
    var postsPerPage = 12;
    // Filter posts based on search and category
    (0,react.useEffect)(function() {
        var filtered = posts;
        // Filter by category
        if (selectedCategory !== "all") {
            filtered = filtered.filter(function(post) {
                var ref;
                return (ref = post.categories) === null || ref === void 0 ? void 0 : ref.some(function(cat) {
                    return cat.slug === selectedCategory;
                });
            });
        }
        // Filter by search query
        if (searchQuery) {
            filtered = filtered.filter(function(post) {
                var ref, ref1;
                return ((ref = post.title) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(searchQuery.toLowerCase())) || ((ref1 = post.summary) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(searchQuery.toLowerCase()));
            });
        }
        setFilteredPosts(filtered);
        setCurrentPage(1); // Reset to first page when filtering
    }, [
        searchQuery,
        selectedCategory,
        posts
    ]);
    // Calculate pagination
    var totalPages = Math.ceil(filteredPosts.length / postsPerPage);
    var startIndex = (currentPage - 1) * postsPerPage;
    var endIndex = startIndex + postsPerPage;
    var currentPosts = filteredPosts.slice(startIndex, endIndex);
    // Format blog posts for BlogCard
    var formatBlogPosts = function(apiPosts) {
        return apiPosts.map(function(post) {
            var ref, ref1, ref2;
            return {
                id: post._id,
                image: (0,utils/* formatBlogImageUrl */.a)((ref = post.coverImage) === null || ref === void 0 ? void 0 : ref.url),
                category: ((ref1 = post.categories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "General",
                readTime: post.readingTime ? "".concat(post.readingTime, " min read") : "5 min read",
                title: post.title,
                description: post.summary || "Read more about this blog post.",
                author: {
                    name: "EPEN Team",
                    avatar: "/chat/chat-admin-avatar.png",
                    date: post.publishedAt ? formatDate(post.publishedAt) : formatDate(new Date().toISOString())
                },
                slug: post.slug,
                body: post.body
            };
        });
    };
    var handlePageChange = function(page) {
        setCurrentPage(page);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var formattedPosts = formatBlogPosts(currentPosts);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Blog",
                description: "Read the latest industry news, interviews, and insights from EPEN Ltd. Stay updated on video plugin development, software solutions, and technology trends. Explore now!",
                keywords: "blog, news, video plugin, software development, epen"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* default */.Z, {
                dateText: "Our blog",
                title: "Blogs",
                titleText: "The latest writings from our team",
                introText: "The latest industry news, interviews, technologies, and resources.",
                aboutData: aboutData,
                contentContainerClass: (news_module_default()).contentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (news_module_default()).mainContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (news_module_default()).sidebar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList_BlogSidebar, {
                                categories: categories,
                                selectedCategory: selectedCategory,
                                onCategoryChange: setSelectedCategory,
                                searchQuery: searchQuery,
                                onSearchChange: setSearchQuery
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (news_module_default()).postsGrid,
                            children: formattedPosts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    formattedPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (news_module_default()).featuredSection,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList_FeaturedBlogCard, {
                                            post: formattedPosts[0],
                                            noBorderRadius: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (news_module_default()).grid,
                                        children: formattedPosts.map(function(post) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                                                post: post,
                                                noBorderRadius: true
                                            }, post.id);
                                        })
                                    }),
                                    totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList_BlogPagination, {
                                        currentPage: currentPage,
                                        totalPages: totalPages,
                                        onPageChange: handlePageChange
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (news_module_default()).emptyState,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "grayDark-400",
                                    children: "No blog posts found"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var news = (BlogListPage);


/***/ }),

/***/ 95656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ formatBlogImageUrl; },
/* harmony export */   "cx": function() { return /* binding */ cx; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4814);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5466);


function cx() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}
/**
 * Formats image URL for blog posts
 * If the URL is an S3 URL, it wraps it in the media view API endpoint
 * @param imageUrl - The image URL from the API
 * @returns Formatted image URL
 */ function formatBlogImageUrl(imageUrl) {
    if (!imageUrl) {
        return "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80";
    }
    // If it's already a media view URL, return as is
    if (imageUrl.includes("/media/view?")) {
        return imageUrl;
    }
    // If it's an S3 URL, wrap it in the media view API
    if (imageUrl.includes("vxfx-io.s3.eu-central-1.amazonaws.com") || imageUrl.includes("s3.eu-central-1.amazonaws.com")) {
        var encodedUrl = encodeURIComponent(imageUrl);
        return "https://api.vxfx.io/media/view?url=".concat(encodedUrl);
    }
    // If it's a direct API file path (like /1733110794800_xxx.webp or https://api.vxfx.io/1733110794800_xxx.webp)
    // These need to be wrapped in /media/view endpoint for Next.js Image to work
    if (imageUrl.startsWith("http") && imageUrl.includes("api.vxfx.io") && !imageUrl.includes("/media/view") || imageUrl.startsWith("/") && imageUrl.match(/\/\d+_[a-f0-9]+\.(jpg|jpeg|png|gif|webp|svg|avif)$/i)) {
        // If it's a relative path, make it absolute
        var absoluteUrl = imageUrl.startsWith("http") ? imageUrl : "https://api.vxfx.io".concat(imageUrl);
        var encodedUrl1 = encodeURIComponent(absoluteUrl);
        return "https://api.vxfx.io/media/view?url=".concat(encodedUrl1);
    }
    // For other URLs (like unsplash), return as is
    return imageUrl;
}


/***/ }),

/***/ 72238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"BlogPagination_paginationContainer__aQ77B","desktopPagination":"BlogPagination_desktopPagination__b60kT","paginationButton":"BlogPagination_paginationButton___8cHn","paginationNumbers":"BlogPagination_paginationNumbers__JQXwm","paginationNumber":"BlogPagination_paginationNumber__j6qPu","active":"BlogPagination_active__8v7r0","mobilePagination":"BlogPagination_mobilePagination__iYjV0","mobilePaginationButton":"BlogPagination_mobilePaginationButton__Bz8Q0","pageInfo":"BlogPagination_pageInfo__3h13U"};

/***/ }),

/***/ 1421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"BlogSidebar_sidebar__JgZFp","dropdownWrapper":"BlogSidebar_dropdownWrapper__PcGRY","dropdownButton":"BlogSidebar_dropdownButton__llyTV","dropdownIcon":"BlogSidebar_dropdownIcon__ki3Fu","open":"BlogSidebar_open__88Uri","dropdownContent":"BlogSidebar_dropdownContent__PMcDG","desktopSidebar":"BlogSidebar_desktopSidebar__Nkb2_","searchContainer":"BlogSidebar_searchContainer__m_TX6","searchInput":"BlogSidebar_searchInput__HJVPZ","searchIcon":"BlogSidebar_searchIcon__oimJo","input":"BlogSidebar_input__4fVuO","categoriesSection":"BlogSidebar_categoriesSection__L20Ja","sectionTitle":"BlogSidebar_sectionTitle__g7GHT","categoriesList":"BlogSidebar_categoriesList__jAqhe","categoryItem":"BlogSidebar_categoryItem__APeRx","active":"BlogSidebar_active__USQc0"};

/***/ }),

/***/ 65929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"featuredCard":"FeaturedBlogCard_featuredCard__3rKYf","noBorderRadius":"FeaturedBlogCard_noBorderRadius__SbkjR","clickable":"FeaturedBlogCard_clickable__QaBI0","notClickable":"FeaturedBlogCard_notClickable__Z6yi1","imageSection":"FeaturedBlogCard_imageSection__enksZ","titleWrapper":"FeaturedBlogCard_titleWrapper__pmoK3","title":"FeaturedBlogCard_title__eD123","descriptionWrapper":"FeaturedBlogCard_descriptionWrapper__MAhuo","description":"FeaturedBlogCard_description__xLl1W","contentSection":"FeaturedBlogCard_contentSection__25Sky","cardTags":"FeaturedBlogCard_cardTags__1nhPU","tag":"FeaturedBlogCard_tag__t86po","readTime":"FeaturedBlogCard_readTime__nf05m","cardAuthor":"FeaturedBlogCard_cardAuthor__qDi_L","authorAvatar":"FeaturedBlogCard_authorAvatar__iMPOR","authorInfo":"FeaturedBlogCard_authorInfo__XxJSu"};

/***/ }),

/***/ 53206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__Rtf5J","noBorderRadius":"BlogCard_noBorderRadius__Hkfyp","clickable":"BlogCard_clickable__V77H8","notClickable":"BlogCard_notClickable__OehVq","cardImage":"BlogCard_cardImage__iMhQW","cardTags":"BlogCard_cardTags__dPSo0","tag":"BlogCard_tag__6nCjW","readTime":"BlogCard_readTime__JCiRX","cardHeader":"BlogCard_cardHeader__7VsMl","cardTitle":"BlogCard_cardTitle__xMqRe","cardDescription":"BlogCard_cardDescription__xZi_p","linkIcon":"BlogCard_linkIcon__Y9iO7","cardAuthor":"BlogCard_cardAuthor__ye5Ff","authorAvatar":"BlogCard_authorAvatar__xqcXF","authorInfo":"BlogCard_authorInfo__dqOja"};

/***/ }),

/***/ 70930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__MAYBo","pattern":"PageWrapper_pattern__3xQmd","headerContainer":"PageWrapper_headerContainer__DAIQD","headerSection":"PageWrapper_headerSection__BJHBX","dateContainer":"PageWrapper_dateContainer__OCDfk","dateText":"PageWrapper_dateText__ErZHL","titleContainer":"PageWrapper_titleContainer__V5tyY","mainTitle":"PageWrapper_mainTitle__yIEnc","introText":"PageWrapper_introText__ZUDXH","contentContainer":"PageWrapper_contentContainer__0fKHq"};

/***/ }),

/***/ 6250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"news_contentContainer__CGDfF","mainContent":"news_mainContent__CZ6zL","postsGrid":"news_postsGrid__TZoY4","featuredSection":"news_featuredSection__ipl1w","grid":"news_grid__2IbNj","emptyState":"news_emptyState__W00JQ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9548,3977,6538,6607,8030,9201,2091,2033,5304,6309,9774,2888,179], function() { return __webpack_exec__(82934); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);